import { ACTION_TYPES } from "@/store/types";

export const snackBarModule = {
  state: {
    content: "",
    color: "",
    icon: "",
  },
  mutations: {
    setContent(state, content) {
      const msg = content.message || content;
      const color = content.color || "";
      const icon = content.icon || "";
      state.content = msg;
      state.color = color;
      state.icon = icon;
    },
    clearContent(state) {
      state.content = "";
      state.color = "";
      state.icon = "";
    },
  },
  actions: {
    [ACTION_TYPES.SHOW_SNACKBAR]: {
      root: true,
      handler({ commit }, content) {
        commit("setContent", content);
      },
    },
    [ACTION_TYPES.HIDE_SNACKBAR]: {
      root: true,
      handler({ commit }, content) {
        commit("clearContent", content);
      },
    },
  },
  getters: {
    snackBarContent(state) {
      return state.content;
    },
    snackBarColor(state) {
      return state.color;
    },
    snackBarIcon(state) {
      return state.icon;
    },
  },
};
